export default __webpack_public_path__ + "static/media/BrandonGrotesque-Medium.11e7b46d.woff";